import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        articles: [],
        pagination: {}
    },
    getters: {
        articles(state) {
            return state.articles;
        },
        pagination(state) {
            return state.pagination;
        }
    },
    actions: {
        async search(context, { terms }) {
            await context.commit("FLUSH_SEARCH_RESULTS");
            return httpClient
                .get(`/api/guest/app/:app_uuid/knowledge/search`, {
                    params: { terms }
                })
                .then(data => context.commit("SET_SEARCH_RESULT", data));
        }
    },
    mutations: {
        SET_SEARCH_RESULT(state, data) {
            state.articles = data.data;
            delete data.data;
            state.pagination = data;
        },
        FLUSH_SEARCH_RESULTS(state) {
            state.articles = [];
            state.pagination = {};
        }
    }
};
